import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { buildApiUrl } from './config';

const HomeworkReadOnlyViewer = () => {
  const { homeworkId } = useParams();
  const navigate = useNavigate();
  const [homework, setHomework] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${buildApiUrl("")}/view-homework-by-id/${homeworkId}`)
      .then((res) => res.json())
      .then((data) => {
        setHomework(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch homework", err);
        setLoading(false);
      });
  }, [homeworkId]);

  if (loading) return <div className="p-6 text-gray-500">Loading...</div>;
  if (!homework) return <div className="p-6 text-red-500">Homework not found.</div>;

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-2">{homework.title}</h1>
      <p className="text-gray-600 mb-4">
        Subject: {homework.subject} | Due: {new Date(homework.dueDate).toLocaleDateString()}
      </p>

      {homework.questions && homework.questions.length > 0 ? (
        <div className="space-y-6">
          {homework.questions.map((q, idx) => (
            <div key={idx} className="p-4 bg-gray-50 border border-gray-200 rounded">
              <h3 className="font-semibold text-gray-800 mb-2">
                Q{idx + 1}: {q.label}
              </h3>

              {q.type === "paragraph" || q.type === "text" ? (
                <textarea
                  value=""
                  disabled
                  placeholder="Student response here"
                  className="w-full border rounded px-3 py-2 text-gray-500 bg-gray-100"
                  rows={q.type === "paragraph" ? 4 : 2}
                />
              ) : q.type === "truefalse" || q.type === "single" ? (
                <ul className="space-y-2">
                  {q.options.map((opt, i) => (
                    <li key={i} className="flex items-center gap-2">
                      <input type="radio" disabled />
                      <span className="text-gray-700">{opt}</span>
                    </li>
                  ))}
                </ul>
              ) : q.type === "multiple" ? (
                <ul className="space-y-2">
                  {q.options.map((opt, i) => (
                    <li key={i} className="flex items-center gap-2">
                      <input type="checkbox" disabled />
                      <span className="text-gray-700">{opt}</span>
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500">No questions found.</p>
      )}

      <div className="mt-6 text-right">
        <button
          onClick={() => navigate(-1)}
          className="px-5 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
        >
          ⬅️ Close
        </button>
      </div>
    </div>
  );
};

export default HomeworkReadOnlyViewer;
